/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/es.object.keys.js";
import { defineComponent as _defineComponent } from 'vue';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { useUserStore } from '@/stores/modules/user';
import { useBackButton } from '@/composables/clickAppBackBtn';
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function(__props) {
        var setupBackPressed = useBackButton().setupBackPressed;
        var userStore = useUserStore();
        var init = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var token, adjustChannel, gaid, commonData;
                return _ts_generator(this, function(_state) {
                    // const userInfo = yxhJsBridge.loadLocalUserInfo() as unknown as string;
                    // if (userInfo) {
                    //   console.log(JSON.parse(userInfo), 'userInfo');
                    //   userStore.update({ userInfo: JSON.parse(userInfo) });
                    // }
                    token = yxhJsBridge.locUserToken();
                    console.log(token, 'token');
                    if (token) {
                        userStore.update({
                            token: token
                        });
                    }
                    // const appVersion = yxhJsBridge.localAppVer() as unknown as string;
                    // console.log(appVersion, 'appVersion');
                    // if (appVersion) {
                    //   userStore.update({ appVersion });
                    // }
                    // const utdKey = yxhJsBridge.loadLocalId() as unknown as string;
                    // console.log(utdKey, 'utdKey');
                    // if (utdKey) {
                    //   userStore.update({ utdKey });
                    // }
                    adjustChannel = yxhJsBridge.loadAdjustChannel();
                    console.log(adjustChannel, 'adjustChannel');
                    if (adjustChannel) {
                        userStore.update({
                            adjustChannel: adjustChannel
                        });
                    }
                    gaid = yxhJsBridge.loadGaid();
                    console.log(gaid, 'gaid');
                    if (gaid) {
                        userStore.update({
                            gaid: gaid
                        });
                    }
                    yxhJsBridge.loadBlackBox();
                    window.localBlackBox = function(blackbox) {
                        console.log(blackbox, 'blackbox');
                        if (blackbox) {
                            userStore.update({
                                blackbox: blackbox
                            });
                        }
                    };
                    commonData = yxhJsBridge.loadCommonPointData();
                    if (commonData) {
                        console.log(JSON.parse(commonData), 'commonData');
                        userStore.update({
                            commonData: _object_spread_props(_object_spread({}, JSON.parse(commonData)), {
                                userPlatType: 'H5'
                            })
                        });
                    }
                    // 设置返回按钮功能
                    setupBackPressed();
                    return [
                        2
                    ];
                });
            });
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        init();
        onUnmounted(function() {
            window.localBlackBox = function() {};
        });
        return {
            __sfc: true,
            setupBackPressed: setupBackPressed,
            userStore: userStore,
            init: init
        };
    }
});
